import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 34,
  medium: 26,
  small: 17,
  xSmall: 14
};
const CartThreeDigitIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M3.55005 5.84998H8.09612L11.339 19.6299H23.7629L25.4246 13.24H26.4508L24.5577 20.63H10.544L7.30405 6.84998H3.55005V5.84998Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M12.5901 23.03C12.5901 23.643 12.0931 24.14 11.4801 24.14C10.867 24.14 10.3701 23.643 10.3701 23.03C10.3701 22.4169 10.867 21.92 11.4801 21.92C12.0931 21.92 12.5901 22.4169 12.5901 23.03Z",
        fill: "currentColor"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "path",
      {
        d: "M24 24.14C24.6131 24.14 25.11 23.643 25.11 23.03C25.11 22.4169 24.6131 21.92 24 21.92C23.387 21.92 22.89 22.4169 22.89 23.03C22.89 23.643 23.387 24.14 24 24.14Z",
        fill: "currentColor"
      }
    )
  );
};
CartThreeDigitIcon.iconName = "CartThreeDigitIcon";

export { CartThreeDigitIcon };
